export default __webpack_public_path__ + "static/media/icon_started.11e6d97c.svg";